import { inject, Injectable } from '@angular/core';

import { GridState } from 'ag-grid-enterprise';

import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AgGridStateService {
  private readonly localStorageService = inject(LocalStorageService);

  static readonly RESULTS_TABLE_GRID_STATE_KEY = 'resultsTableGridState';
  static readonly SCHAEFFLER_BOM_TABLE_GRID_STATE_KEY =
    'schaefflerBomTableGridState';
  static readonly VITESCO_BOM_TABLE_GRID_STATE_KEY = 'vitescoBomTableGridState';
  static readonly CALCULATIONS_TABLE_DEFAULT_GRID_STATE_KEY =
    'calculationsTableDefaultGridState';
  static readonly CALCULATIONS_TABLE_MINIFIED_GRID_STATE_KEY =
    'calculationsTableMinifiedGridState';
  static readonly PRICING_TABLE_GRID_STATE_KEY = 'pricingTableGridState';

  static readonly IGNORED_EVENTS = new Set([
    'gridInitializing',
    'scroll',
    'pagination',
    'columnSizing',
  ]);

  getGridState(key: string): GridState {
    return this.localStorageService.getItem<GridState>(key, true);
  }

  saveGridState(key: string, state: GridState): void {
    const customState: GridState = {
      ...state,
      partialColumnState: true,
      pagination: undefined,
      scroll: undefined,
      cellSelection: undefined,
      rowSelection: undefined,
      rangeSelection: undefined,
      rowGroupExpansion: undefined,
      focusedCell: undefined,
    };

    this.localStorageService.setItem<GridState>(key, customState, true);
  }
}
